var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonWalkingFilled = function SvgPersonWalkingFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M22 23a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1c0-1.654 1.346-3 3-3h4V7.851c-.038-.022-6.615-5.14-6.615-5.14a1 1 0 1 1 1.23-1.576L9.844 6h3.655c1.93 0 3.5 1.57 3.5 3.5v3a3.5 3.5 0 0 1-2 3.149V20h4A3.005 3.005 0 0 1 22 23m-11-3h2v-4h-2z"
  })));
};
export default SvgPersonWalkingFilled;